// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import OrderNotify from "components/Notifications/order_notify";
// Material UI
import { CircularProgress } from "@material-ui/core";
// Infrastructure
import { UsersAPI } from "views/Users/infrastructure";
import { BillingAPI } from "views/Order/infrastructure";
// Vendor
import { showNotify, updatePlan } from "vendor/application/disptach";
import "views/Order/styles/index.scss";

class Status extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: "",
      request: ""
    };
  }

  componentDidMount() {
    this.getInfoOrder();
  }

  getInfoOrder = async (i = 0) => {
    const { user, access } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      let res = await obj.get_order_by_id(this.props.id);

      this.setState({ plan: res.concepts.concepts[0].name });
      this.handleCodeError(res, i);
    } catch (err) {
      var data = { message: err, from: "order", severity: "error" };
      this.props.dispatch(showNotify(data));
      this.props.history.push("/");
    }
  };

  getPlan = async () => {
    const { access, user } = this.props.data;

    try {
      const obj = new UsersAPI(access.userId, access, this.props, user);
      let res = await obj.get_account_by_id(user.account_id);

      this.props.dispatch(updatePlan(res));
    } catch (err) {}
  };

  handleCodeError = (redsys, i) => {
    var req;
    if (redsys.process_result === "0" && i !== 4) {
      setTimeout(() => {
        this.getInfoOrder(i + 1);
      }, 2000);
    } else {
      var responses = false;
      var redsys_responses_ok = [];
      for (let ii = 0; ii < 100; ii++) {
        if (ii.toString().length === 1) {
          redsys_responses_ok.push(`000${ii}`);
        } else {
          redsys_responses_ok.push(`00${ii}`);
        }
      }

      redsys_responses_ok.forEach((element) => {
        if (element === redsys.process_redsys_result) {
          responses = true;
        }
      });

      if (!responses && redsys.process_redsys_result) {
        req = { type: "error", error: redsys.process_redsys_result };
      } else if (
        redsys.process_result === "2" ||
        redsys.process_result === "0"
      ) {
        req = { type: "error", error: "internal_server" };
      } else {
        this.getPlan();
        req = { type: "success" };
      }

      this.setState({ request: req });
    }
  };

  handleAction = (e, type) => {
    e.preventDefault();
    switch (type) {
      case "success":
        this.props.history.push("/");
        break;
      case "error":
        this.props.history.push(`/order/${this.state.plan}`);
        break;
    }
  };

  render() {
    const { plan, request } = this.state;
    const { t } = this.props;
    return (
      plan && (
        <div style={{ marginTop: 20 }} className="man-order notify">
          <div className={plan}>
            <div className={`man-header ${plan}`}>
              <div>
                <p
                  dangerouslySetInnerHTML={{ __html: t(`plans:${plan}.name`) }}
                ></p>
              </div>
            </div>
            <div className="man-content">
              {request ? (
                <OrderNotify
                  domain={"order_status"}
                  onClick={this.handleAction}
                  type={request.type}
                  error={request.error}
                />
              ) : (
                <div className={`${plan}_progress`}>
                  <span>{this.props.t("status")}</span>
                  <CircularProgress size={75} />
                </div>
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(Status);
export default withTranslation("order")(withRouter(connect_));
